import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-[1280px] flex-col items-center justify-center px-4 py-20 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-500">
        <i className="ri-planet-line text-3xl"></i>
      </span>
      <p className="mt-6 font-heading text-6xl font-black text-primary-500 md:text-7xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        这颗星还没有被点亮
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的页面不存在：<span className="font-mono text-foreground-700">{location.pathname}</span>
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-accent-600 cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/news"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-600 cursor-pointer"
        >
          浏览资讯
        </Link>
      </div>
    </div>
  );
}